import {createDomainEvent, DomainEvent} from './domain-event'

export const ProfileEventTypes = {
  FormFilled: 'profile.form_filled',
} as const

export type ProfileFormSavedEvent = DomainEvent

export const ProfileEvents = {
  formFilled(): ProfileFormSavedEvent {
    return createDomainEvent(ProfileEventTypes.FormFilled)
  },
}
